import { Minus, Plus, SlidersHorizontal } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@akuna/ui";

export interface PlanAdjustRowProps {
  onGive: () => void;
  onRemove: () => void;
}

/**
 * A faixa de ajuste do design: as duas ações lado a lado, com a explicação de
 * que todo ajuste exige motivo. Um botão solto escondia essa regra.
 *
 * As cores vêm por `!` porque a regra de hover do `.akuna-button--outline`
 * tem especificidade maior que as utilitárias do Tailwind.
 */
export function PlanAdjustRow({ onGive, onRemove }: PlanAdjustRowProps) {
  const { t } = useTranslation("patients");

  return (
    <div className="mt-4 flex flex-wrap items-center gap-3 rounded-lg border border-border bg-cream-50 px-4 py-3.5">
      <SlidersHorizontal className="h-[18px] w-[18px] shrink-0 text-primary" aria-hidden />
      <div className="min-w-[12rem] flex-1">
        <p className="text-[0.8125rem] font-semibold text-foreground">{t("planCard.adjustTitle")}</p>
        <p className="text-xs text-muted-foreground">{t("planCard.adjustHint")}</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="!border-state-success/30 !text-state-success-foreground hover:!bg-state-success-soft"
          onClick={onGive}
        >
          <Plus className="me-1.5 h-4 w-4" aria-hidden />
          {t("stayPlanAdjustments.give")}
        </Button>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="!border-state-danger/30 !text-state-danger-foreground hover:!bg-state-danger-soft"
          onClick={onRemove}
        >
          <Minus className="me-1.5 h-4 w-4" aria-hidden />
          {t("stayPlanAdjustments.remove")}
        </Button>
      </div>
    </div>
  );
}
